/* eslint-disable @typescript-eslint/no-explicit-any */
import { TargetApp } from "../types/notification";
import backendApi from "./backendApi";
import { showSnackbar } from "./snackbar.service";

const routePrefix = "notification";

export default {
  async get({
    page,
    pageSize,
  }: {
    page?: number;
    pageSize?: number;
  }): Promise<any> {
    try {
      const result = await backendApi()?.post(`${routePrefix}/get`, {
        page,
        pageSize,
        targetApp: TargetApp.DataLake,
      });
      if (result?.status != 200) {
        showSnackbar(
          "danger",
          "Error",
          result?.data.message || "Could not load notifications."
        );
        return null;
      }
      return result;
    } catch (error: any) {
      if (error?.response?.status) {
        showSnackbar(
          "danger",
          "Error",
          error?.response?.data?.message || "Could not load notifications."
        );
        return null;
      }
    }
  },
  async read(ids: string[]): Promise<any> {
    try {
      const result = await backendApi()?.post(`${routePrefix}/read`, { ids });
      if (result?.status != 200) {
        showSnackbar(
          "danger",
          "Error",
          result?.data.message || "Could not mark notifications as read."
        );
        return null;
      }
      return result;
    } catch (error: any) {
      if (error?.response?.status) {
        showSnackbar(
          "danger",
          "Error",
          error?.response?.data?.message || "Could not mark notifications as read."
        );
        return null;
      }
    }
  },
};
